import { createContext } from "react";
import PropTypes from "prop-types";

export const SsrLdFlagsContext = createContext({});

export const SsrLdFlagsProvider = ({ children, ldFlags }) => {
  return (
    <SsrLdFlagsContext.Provider value={ldFlags}>
      {children}
    </SsrLdFlagsContext.Provider>
  );
};

SsrLdFlagsProvider.propTypes = {
  children: PropTypes.element,
  ldFlags: PropTypes.shape({})
};
SsrLdFlagsProvider.defaultProps = {
  children: null,
  ldFlags: {}
};
